const isAppName = (appName: string): boolean => {
  const app = process.env.REACT_APP_NAME
  return appName.toLowerCase() === app?.toLowerCase()
}

const getAppName = (): string => {
  const fromEnv = (process.env.REACT_APP_NAME ?? 'ge').toLowerCase()

  if (typeof window !== 'undefined') {
    const host = window.location.hostname
    if (host.includes('acai-brasil')) return 'acai-brasil'
    if (host.includes('la-condesa')) return 'la-condesa'
    if (host.includes('el-diez') || host.includes('eldiez')) return 'el-diez'
  }

  return fromEnv
}

const isTeaConnection = (): boolean => {
  return isAppName('tea')
}

export const ConfigUtils = {
  isAppName,
  isTeaConnection,
  getAppName,
}
